import * as modal from './modal'

export function splitAccountAndOrders() {
  if (window.location.search === '?orders') {
    $('.js-myfoo__orders').show()
    $('.nav-info__link')
      .removeClass('is-active')
      .filter('.nav-info__link--orders')
      .addClass('is-active')
  } else {
    $('.js-myfoo__account').show()
  }
}

export function loginControls() {
  const $recoverPasswordBtn = $('#RecoverPasswordButton')

  if (location.hash === '#recover') {
    modal.open('RecoverPasswordForm')
  }

  $recoverPasswordBtn.on('click', function(event) {
    modal.open('RecoverPasswordForm')
  })

}

export function registerControls() {
  console.log('register page')
}



// WEBPACK FOOTER //
// ./myfoo.js